import { createStore, combineReducers } from 'redux';

import { loadState } from 'service/storage';
import { appReducer } from './reducers';


const getStore = () => {
  const rootReducer = combineReducers({
    app: appReducer,
  });

  const store = createStore(
    rootReducer,
    loadState(),
  );

  return store;
};

const AppStore = getStore();

export default AppStore;
